import Vue from 'vue'
import VueRouter from 'vue-router'
import Layouts from '@/components/Layouts'
import Login from '../views/Login'
import Home from '../views/Home'
import Graph from '../views/Graph'
import GIS from '../views/GIS'
import Planner from '../views/Planner'
import Report from '../views/Report'
import Alert from '../views/Alert'
import TimeSeries from "../views/TimeSeries";
Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/',
        name: 'layouts',
        redirect: 'home',
        component: Layouts,
        children: [
            {
                path: 'home',
                name: 'home',
                component: Home
            },
            {
                path: 'graph',
                name: 'graph',
                component: Graph
            },
            {
                path: 'gis',
                name: 'gis',
                component: GIS
            },
            {
                path: 'planner',
                name: 'planner',
                component: Planner
            },
            {
                path: 'report',
                name: 'report',
                component: Report
            },
            {
                path: 'alert',
                name: 'alert',
                component: Alert
            },
        ],
    },
  {
    path: '/time_series',
    name: 'time_series',
    component: TimeSeries,
  }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
